<router-outlet>
    <div class="preloader" [ngStyle]="{visibility: loadingVisible!='true' ? 'hidden' : 'visible' }">
        <div class="loading">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>
</router-outlet>
